import { Link } from 'react-router-dom';
import CustomPageTiles from '../components/CustomPageTiles';
import Header from '../components/Header';

function CapMisc() {
  return <>
    <Header />
    
    <div id="tiles">
        <Link id="match-animals" className='link' to="/cap/animals">
            <span>Čo jedia zvieratá</span>
        </Link>
		    <Link id="truefalse_teeth" className="link" to='/cap/truefalse_teeth'>
        	<span>Zdravé Zuby</span>
      	</Link>
        <CustomPageTiles path="/cap" />
    </div>
  </>
}

export default CapMisc;
